module.exports = __webpack_public_path__ + "media/images/proof_links/rottentomatoes-d465a7071c6d36ae4704fc70f1570139.svg";